import { LastViewedObject } from "../../types/types";
import List from "../List";
import Page from "../Page";
import useFetchPage from "../hooks/useFetchPage";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Templates = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        <List isTemplates={true} />
      </Page>
    )
  );
};

export default Templates;
